<template>
  <div class="c-page">
    <slot></slot>
  </div>
</template>
<script>
  export default{
    name: 'c-page',
    data () {
      return {}
    }
  }
</script>
<style lang="scss" scoped>
  @import "./index";
</style>



// WEBPACK FOOTER //
// index.vue?72e75877